import React, { useState } from 'react';
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  FormControlLabel,
  Grid,
  Typography,
} from '@mui/material';
import CHECK from './assets/CHECK.svg';
import { getInsurers } from '@modals/ModalAmpliaIntegral/utils';
import { useCopyQuoteStore } from '@store/copyQuoteStorage';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { grey } from '@mui/material/colors';
import Divider from '@mui/material/Divider';
import { usePolicyStore } from '@store/policyStore';

interface GenericModalProps {
  open: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  title: string;
  cardTitle: string;
  titleCheck: string;
  pagoMes: string;
  textCobertura: string;
  montoCobertura: string;
  textTotalPlus: string;
  montoTotalPlus: string;
  textPrimerPago: string;
  montoPrimerPago: string;
  textMasPagos: string;
  montoMasPagos: string;
  textCostoAnual: string;
  montoCostoAnual: string;
  data?: any;
  appear: string;
  onClickNo: () => void;
  onClickAgregar: () => void;
}

const GenericModal: React.FC<GenericModalProps> = ({
  open,
  setOpenModal,
  title = '',
  cardTitle = '',
  titleCheck = '',
  pagoMes = '',
  textCobertura = '',
  montoCobertura = '',
  textTotalPlus = '',
  montoTotalPlus = '',
  textPrimerPago = '',
  montoPrimerPago = '',
  textMasPagos = '',
  montoMasPagos = '',
  textCostoAnual = '',
  montoCostoAnual = '',
  data = getInsurers,
  appear = '',
  onClickNo,
  onClickAgregar,
}) => {
  const [checkedAgregar, setCheckedAgregar] = useState(false);
  const { PaymentOptionCopy } = useCopyQuoteStore();
  const handleChangeAgregar = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    setCheckedAgregar(event.target.checked);
  };
  const { policy } = usePolicyStore();
  let isChecked = checkedAgregar;
  let div = policy.payment_label;

  return (
    <>
      <Dialog
        open={open}
        maxWidth="xl"
        PaperProps={{ sx: { maxHeight: '98%' } }}
      >
        <Box
          sx={{
            width: { xs: '100%', sm: '100%', lg: '558px' },
            padding: '0px 16px 0px 16px',
            mt: 3,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <IconButton
            aria-label="close"
            onClick={() => {
              setOpenModal(false);
            }}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          <Typography
            sx={{ fontWeight: 700, fontSize: '20px', textAlign: 'center' }}
          >
            {title}
          </Typography>
          <Box
            border={isChecked ? '1px solid #039ECC' : '1px solid #C7C7C7'}
            style={{ background: isChecked ? '#F2FAFC' : '' }}
            marginTop={'16px'}
            sx={{
              padding: '12px 16px 12px 16px',
              width: { xs: '100%', sm: '100%', lg: '330px' },
              height: 'auto',
              borderRadius: '4px 4px 0px 0px',
              gap: 2,
            }}
          >
            <Grid
              container
              direction="column"
              justifyContent="flex-start"
              alignItems="flex-start"
              gap={2}
            >
              <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start"
                spacing={{ xs: 0, sm: 4 }}
              >
                <Grid item xs={6}>
                  <Typography
                    sx={{
                      color: '#000000',
                      fontSize: '16',
                      fontWeight: 700,
                      mt: 1,
                    }}
                  >
                    {cardTitle}
                  </Typography>
                </Grid>
                <Grid item xs={6} sx={{ textAlign: 'end' }}>
                  <FormControlLabel
                    value={'start'}
                    control={
                      <Checkbox
                        sx={{
                          '&:hover': { bgcolor: 'transparent' },
                          color: '#c7c7c7',
                        }}
                        name="agregar"
                        checked={checkedAgregar}
                        onChange={handleChangeAgregar}
                      />
                    }
                    label={titleCheck}
                    labelPlacement="start"
                  />
                </Grid>
              </Grid>
              <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
                gap={2}
              >
                {data.map((p: any, i: number) => {
                  return (
                    <Grid
                      container
                      direction="row"
                      justifyContent="space-between"
                      alignItems="flex-start"
                      spacing={{ xs: 0, sm: 0 }}
                      gap={0}
                    >
                      <Grid item xs={1}>
                        <img src={CHECK} alt="check" />
                      </Grid>
                      <Grid item xs={10}>
                        <Typography
                          style={{
                            color: 'var(--Black, #212121)',
                            fontFamily: 'Montserrat',
                            fontSize: '12px',
                            fontStyle: 'normal',
                            fontWeight: 400,
                            lineHeight: 'normal',
                          }}
                        >
                          {' '}
                          {p.description}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={1}
                        sx={{ display: 'flex', justifyContent: 'flex-end' }}
                      >
                        <Typography
                          style={{
                            color: 'var(--Black, #212121)',
                            textAlign: 'center',
                            fontFamily: 'Montserrat',
                            fontSize: '12px',
                            fontStyle: 'normal',
                            fontWeight: 400,
                            lineHeight: 'normal',
                          }}
                        >
                          {' '}
                          {p.tooltip}
                        </Typography>
                      </Grid>
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
          </Box>

          <Grid
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
            border={isChecked ? '1px solid #039ECC' : '1px solid #C7C7C7'}
            style={{
              background: isChecked ? '#C0E6F2' : '#F4F4F4',
              height: '44px',
            }}
            sx={{ width: { xs: '100%', sm: '100%', lg: '330px' } }}
          >
            <Typography
              sx={{
                fontSize: '16px',
                fontWeight: 700,
                color: '#212121',
                paddingRight: 2,
              }}
            >
              $
              {parseFloat(parseFloat(pagoMes).toFixed(3)).toLocaleString(
                'es-MX',
                { minimumFractionDigits: 3 }
              )}{' '}
              /{' ' + div}
            </Typography>
          </Grid>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start"
            marginTop={'16px'}
          >
            <Typography
              sx={{ color: '#212121', fontSize: '14px', fontWeight: 400 }}
            >
              {textCobertura}
            </Typography>
            <Typography
              sx={{
                fontSize: '16px',
                fontWeight: 600,
                color: '#212121',
              }}
            >
              $
              {parseFloat(parseFloat(montoCobertura).toFixed(2)).toLocaleString(
                'es-MX',
                { minimumFractionDigits: 2 }
              )}
            </Typography>
          </Grid>

          {isChecked && (
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="flex-start"
              marginTop={'8px'}
              style={{ background: isChecked ? '#F4F4F4' : '' }}
            >
              <Typography
                sx={{
                  fontFamily: 'Montserrat',
                  fontWeight: 400,
                  fontSize: '14px',
                  lineHeight: '24px',
                }}
              >
                {textTotalPlus}
              </Typography>
              <Typography>
                $
                {parseFloat(
                  parseFloat(montoTotalPlus).toFixed(2)
                ).toLocaleString('es-MX', { minimumFractionDigits: 2 })}
              </Typography>
            </Grid>
          )}
          {appear === 'true' && isChecked && (
            <>
              <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start"
                marginTop={'8px'}
              >
                <Typography
                  sx={{ color: '#212121', fontSize: '14px', fontWeight: 400 }}
                >
                  {textPrimerPago}
                </Typography>
                <Typography
                  sx={{ color: '#212121', fontSize: '14px', fontWeight: 400 }}
                >
                  $
                  {parseFloat(
                    parseFloat(montoPrimerPago).toFixed(2)
                  ).toLocaleString('es-MX', { minimumFractionDigits: 2 })}
                </Typography>
              </Grid>
              {PaymentOptionCopy.label !== 'Anual' && (
                <ul style={{ margin: 0, width: '100%' }}>
                  <li>
                    <Grid
                      container
                      direction="row"
                      justifyContent="space-between"
                      alignItems="flex-start"
                    >
                      <Typography
                        sx={{
                          color: '#212121',
                          fontSize: '14px',
                          fontWeight: 400,
                        }}
                      >
                        {textMasPagos}
                      </Typography>
                      <Typography
                        sx={{
                          color: '#212121',
                          fontSize: '14px',
                          fontWeight: 400,
                        }}
                      >
                        $
                        {parseFloat(
                          parseFloat(montoMasPagos).toFixed(2)
                        ).toLocaleString('es-MX', { minimumFractionDigits: 2 })}
                      </Typography>
                    </Grid>
                  </li>
                </ul>
              )}
            </>
          )}
          <Box marginBottom={'8px'} />
          <Divider color="#C7C7C7" sx={{ height: 1, width: '100%' }} />
          {isChecked ? (
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="flex-start"
              marginTop={'8px'}
            >
              <Typography
                sx={{ color: '#212121', fontSize: '16px', fontWeight: 700 }}
              >
                {textCostoAnual}
              </Typography>
              <Typography
                sx={{ color: '#212121', fontSize: '16px', fontWeight: 700 }}
              >
                $
                {parseFloat(
                  parseFloat(montoCostoAnual).toFixed(2)
                ).toLocaleString('es-MX', { minimumFractionDigits: 2 })}
              </Typography>
            </Grid>
          ) : (
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="flex-start"
              marginTop={'8px'}
            >
              <Typography
                sx={{ color: '#212121', fontSize: '16px', fontWeight: 700 }}
              >
                {textCostoAnual}
              </Typography>
              <Typography
                sx={{ color: '#212121', fontSize: '16px', fontWeight: 700 }}
              >
                $
                {parseFloat(
                  parseFloat(montoCobertura).toFixed(2)
                ).toLocaleString('es-MX', { minimumFractionDigits: 2 })}
              </Typography>
            </Grid>
          )}
          <Button
            fullWidth
            variant="contained"
            disabled={!isChecked}
            sx={{
              height: '56px',
              fontSize: '16px',
              fontStyle: 'normal',
              fontWeight: '600',
              lineHeight: '24px',
              mt: 3,
            }}
            onClick={onClickAgregar}
          >
            Agregar
          </Button>
          <Button
            fullWidth
            variant="text"
            sx={{
              height: '56px',
              fontSize: '16px',
              fontStyle: 'normal',
              fontWeight: '600',
              lineHeight: '24px',
              mt: 3,
            }}
            onClick={() => {
              onClickNo();
            }}
          >
            No por el momento
          </Button>
          <Box sx={{ mt: 3 }} />
        </Box>
      </Dialog>
    </>
  );
};
export default GenericModal;
